import { motion } from "framer-motion";
import { STATE_STYLES } from "../lib/planner";

const HERO_MOTION = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};

const AFFIRMATIONS = {
  Rest: "be tender with yourself today",
  Gentle: "small and kind is enough",
  Steady: "steady hands, steady heart",
  Push: "ride the bright wave",
};

export const CapacityHero = ({ result, progress }) => {
  if (!result) return null;
  const s = STATE_STYLES[result.label] || STATE_STYLES.Steady;
  const p = progress || { frac: 0, done: 0, total: 0 };
  const deg = Math.round(p.frac * 360);
  const complete = p.total > 0 && p.done >= p.total;
  return (
    <div>
      <motion.div
        {...HERO_MOTION}
        data-testid="capacity-progress-ring"
        className="rounded-[28px] p-[6px] transition-all duration-700"
        style={{ background: `conic-gradient(${s.hex} ${deg}deg, rgba(120,120,120,0.14) ${deg}deg)` }}
      >
        <div
          data-testid="capacity-hero-card"
          className={`rounded-3xl border ${s.bg} ${s.border} p-8 sm:p-10 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)]`}
        >
          <p className={`text-xs font-bold uppercase tracking-[0.25em] ${s.subtext} mb-4`}>
            Today · {result.phase} phase · Cycle day {result.cycle_day}
          </p>
          <div
            data-testid="capacity-score-display"
            className={`font-heading leading-none ${s.text}`}
            style={{ fontSize: "clamp(4.5rem, 19vw, 7.5rem)", fontWeight: 600 }}
          >
            {result.capacity_pct}%
          </div>
          <div className="flex items-center justify-center gap-2 mt-3">
            <span className={`h-2.5 w-2.5 rounded-full ${s.indicator}`} />
            <span className={`font-heading text-2xl font-bold ${s.text}`} data-testid="capacity-label">
              {result.label}
            </span>
          </div>
          <p className={`mt-2 text-lg font-heading italic ${s.subtext}`} data-testid="capacity-affirmation">
            {AFFIRMATIONS[result.label]}
          </p>
          <p className={`mt-5 text-xl font-heading ${s.text}`} data-testid="capacity-headline">
            {result.headline}
          </p>
          {(result.label === "Rest" || result.label === "Gentle") && (
            <p className={`mt-4 text-base font-heading italic ${s.subtext} max-w-sm mx-auto`} data-testid="capacity-reframe">
              "{result.reframe}"
            </p>
          )}
          {result.recovery && (
            <div
              data-testid="recovery-readout"
              className={`mt-6 pt-5 border-t ${s.border} flex items-center justify-center gap-6`}
            >
              <div className="text-center">
                <p className={`text-xs font-bold uppercase tracking-[0.15em] ${s.subtext}`}>Recovery</p>
                <p className={`font-heading text-2xl font-bold ${s.text}`} data-testid="recovery-score">
                  {result.recovery.score}
                  <span className="text-sm font-semibold ml-1">{result.recovery.label}</span>
                </p>
              </div>
              {result.recovery.hrv != null && (
                <div className="text-center">
                  <p className={`text-xs font-bold uppercase tracking-[0.15em] ${s.subtext}`}>HRV</p>
                  <p className={`font-heading text-2xl font-bold ${s.text}`}>{result.recovery.hrv}<span className="text-sm font-medium ml-0.5">ms</span></p>
                </div>
              )}
              {result.recovery.rhr != null && (
                <div className="text-center">
                  <p className={`text-xs font-bold uppercase tracking-[0.15em] ${s.subtext}`}>Resting HR</p>
                  <p className={`font-heading text-2xl font-bold ${s.text}`}>{result.recovery.rhr}<span className="text-sm font-medium ml-0.5">bpm</span></p>
                </div>
              )}
            </div>
          )}
        </div>
      </motion.div>
      {p.total > 0 && (
        <p
          data-testid="capacity-progress-caption"
          className={`text-center text-xs mt-3 ${complete ? "text-[#b1543b] dark:text-emerald-400 font-semibold" : "text-stone-400 dark:text-stone-500"}`}
        >
          {complete ? "Full circle — everything that mattered today is done 🌿" : `${p.done}/${p.total} done · your ring fills as you complete today`}
        </p>
      )}
    </div>
  );
};
